import { gql } from '@apollo/client';
export const GetAllCoach = gql `
  {
    GetAllCoach {
      id
      userId
      franchisorId
      user {
        firstName
        surname
        email
        isActive
        idNumber
      }
      siteAddressId
      siteAddress {
        id
        province {
          id
          description
        }
        name
        addressLine1
        addressLine2
        addressLine3
        postalCode
        ward
      }
      areaOfOperation
      secondaryAreaOfOperation
      startDate
    }
  }
`;
export const GetCoachById = gql `
  query GetCoachById($id: UUID) {
    GetCoachById(id: $id) {
      areaOfOperation
      secondaryAreaOfOperation
      startDate
      siteAddressId
      siteAddress {
        id
        province {
          id
          description
        }
        name
        addressLine1
        addressLine2
        addressLine3
        postalCode
        ward
      }
      franchisorId
    }
  }
`;
export const CreateCoach = gql `
  mutation createCoach($input: CoachInput) {
    createCoach(input: $input) {
      id
    }
  }
`;
export const UpdateCoach = gql `
  mutation updateCoach($input: CoachInput, $id: UUID) {
    updateCoach(input: $input, id: $id) {
      id
    }
  }
`;
export const DeleteCoach = gql `
  mutation deleteCoach($id: UUID!) {
    deleteCoach(id: $id)
  }
`;
//# sourceMappingURL=coach.js.map